<template>
  <div class="login-container">
    <div class="mask"></div>

    <el-card class="login-card">
      <h2 class="title">废旧金属回收后台登录</h2>

      <el-form :model="form" @submit.native.prevent="handleLogin">
        <el-form-item label="用户名">
          <el-input v-model="form.username" placeholder="请输入用户名"></el-input>
        </el-form-item>

        <el-form-item label="密码">
          <el-input
            type="password"
            v-model="form.password"
            placeholder="请输入密码"
          ></el-input>
        </el-form-item>

        <el-button
          type="primary"
          :loading="loading"
          @click="handleLogin"
          style="width: 100%;"
        >
          登录
        </el-button>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      form: { username: "", password: "" },
      loading: false
    };
  },
  methods: {
    async handleLogin() {
      if (!this.form.username || !this.form.password) {
        this.$message.error("请输入用户名和密码");
        return;
      }

      this.loading = true;
      try {
        const res = await axios.post(
          "https://wx.hzxcet.com/api/login",
          {
            username: this.form.username,
            password: this.form.password
          },
          {
            headers: { "Content-Type": "application/json" }
          }
        );

        const data = res.data || {};

        // 后端返回格式：{ code:0, msg:'ok', token:'xxxx' }
        if (data.code === 0 && data.token) {
          localStorage.setItem("token", data.token);

          this.$message.success("登录成功");
          this.$router.push("/home");
        } else {
          this.$message.error(data.msg || "用户名或密码错误");
        }
      } catch (err) {
        console.error(err);
        this.$message.error("网络错误，请稍后再试");
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
/* 🌄 背景图容器 */
.login-container {
  width: 100%;
  height: 100vh;
  background: url("@/assets/bg.jpg") no-repeat center center;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

/* 半透明遮罩 */
.mask {
  position: absolute;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.35);
}

/* 登录卡片 */
.login-card {
  width: 360px;
  padding: 25px 30px;
  position: relative;
  z-index: 2;
  backdrop-filter: blur(4px);
  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
}

.title {
  text-align: center;
  margin-bottom: 20px;
  color: #000;
}
</style>
